import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index(params) {
    const res = await base.index({
      modelName: 'module_page',
      params,
    });
    return res;
  },
}